import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

const IMG = {
  refinery: "https://images.pexels.com/photos/10396411/pexels-photo-10396411.jpeg",
  tanker: "https://images.unsplash.com/photo-1598408745613-178751e2ccde",
  sugar: "https://images.unsplash.com/photo-1457414104202-9d4b4908f285",
  coffee: "https://images.unsplash.com/photo-1690983326555-8b8e27843a32",
};

const Card = ({ tag, title, body, image, span = "", testid }) => (
  <div className={`relative overflow-hidden border border-line bg-parchment ${span}`} data-testid={testid}>
    <div className="relative h-72 md:h-80">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/20 to-transparent" />
      <div className="absolute bottom-5 left-5 right-5">
        <div className="overline !text-brass">{tag}</div>
        <h3 className="h-serif text-3xl text-parchment mt-2">{title}</h3>
      </div>
    </div>
    <p className="text-sub text-sm leading-relaxed p-6">{body}</p>
  </div>
);

export default function Commodities() {
  return (
    <div className="bg-parchment min-h-screen" data-testid="commodities-page">
      <PublicNav />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="overline">Asset Classes — Categories only. Suppliers undisclosed.</div>
        <h1 className="h-serif text-5xl md:text-7xl text-ink mt-4 leading-[1.0] max-w-4xl">
          Two markets we cover with conviction.
        </h1>
        <p className="text-sub mt-6 max-w-2xl leading-relaxed">
          The categories below describe what we broker, not who we broker for.
          Origin, lot grading, and pricing tiers are made available inside the
          vetted platform after corporate intake.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20">
        <div className="grid md:grid-cols-6 gap-6">
          <Card tag="Energy" title="Crude Oil"
                body="Sourced light/medium grades for refiners and trading houses. Brent and WTI blended cargoes, vessel sizes from Aframax to VLCC, with documented provenance and quality certificates per cargo."
                image={IMG.tanker} span="md:col-span-4" testid="commodity-crude" />
          <Card tag="Energy" title="Refined Petroleum"
                body="Gasoil (10 ppm / EN 590), Jet A-1, gasoline (RON 92/95), fuel oil. ARA, USGC and Fujairah lifting capability."
                image={IMG.refinery} span="md:col-span-2" testid="commodity-refined" />
          <Card tag="Soft Commodities" title="Bulk Sugar — ICUMSA 45"
                body="Premium refined white sugar, ICUMSA 45 grade. 50kg polypropylene bags or jumbo bags, FOB Santos / Durban with SGS or equivalent QC sampling."
                image={IMG.sugar} span="md:col-span-3" testid="commodity-sugar" />
          <Card tag="Soft Commodities" title="Green Coffee Bean Sourcing"
                body="Arabica and Robusta from Brazil, Colombia, Ethiopia and Vietnam. Screen-grade sorted, defect-counted, and cupping scores supplied per lot."
                image={IMG.coffee} span="md:col-span-3" testid="commodity-coffee" />
        </div>
      </section>

      <section className="bg-ink text-parchment grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 flex flex-col md:flex-row items-start md:items-end justify-between gap-10">
          <div>
            <div className="overline !text-brass">Procurement next step</div>
            <h2 className="h-serif text-4xl md:text-5xl mt-3 max-w-2xl leading-tight">
              See pricing tiers, submit an RFQ, calculate freight — inside.
            </h2>
          </div>
          <Link to="/login" className="btn-brass" data-testid="commodities-request-access">
            Request Platform Access →
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
